/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdateSubscriptionRequest = {
  /**
   * The unique identifier of the subscription
   */
  id: string;
  /**
   * Subscription update payload
   */
  updateSubscriptionRequestEntity: components.UpdateSubscriptionRequestEntity;
};

/** @internal */
export const UpdateSubscriptionRequest$inboundSchema: z.ZodType<
  UpdateSubscriptionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  UpdateSubscriptionRequestEntity:
    components.UpdateSubscriptionRequestEntity$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "UpdateSubscriptionRequestEntity": "updateSubscriptionRequestEntity",
  });
});
/** @internal */
export type UpdateSubscriptionRequest$Outbound = {
  id: string;
  UpdateSubscriptionRequestEntity:
    components.UpdateSubscriptionRequestEntity$Outbound;
};

/** @internal */
export const UpdateSubscriptionRequest$outboundSchema: z.ZodType<
  UpdateSubscriptionRequest$Outbound,
  z.ZodTypeDef,
  UpdateSubscriptionRequest
> = z.object({
  id: z.string(),
  updateSubscriptionRequestEntity:
    components.UpdateSubscriptionRequestEntity$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    updateSubscriptionRequestEntity: "UpdateSubscriptionRequestEntity",
  });
});

export function updateSubscriptionRequestToJSON(
  updateSubscriptionRequest: UpdateSubscriptionRequest,
): string {
  return JSON.stringify(
    UpdateSubscriptionRequest$outboundSchema.parse(updateSubscriptionRequest),
  );
}
export function updateSubscriptionRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateSubscriptionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateSubscriptionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateSubscriptionRequest' from JSON`,
  );
}
